var styleDataHash = "0fecd477";
const injectCss = () => {
  var css = `.e4LxQ,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.jy3Yu{align-items:center;color:var(--ricos-settings-text-color,#000);display:flex;font-size:14px;height:40px;width:100%}[dir] .jy3Yu{background-color:#fff}[dir=ltr] .jy3Yu,[dir=rtl] .jy3Yu{padding-left:20px;padding-right:20px}.jy3Yu>*{flex:1}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var list_item_toggle_default = {
  "fontElementMap": "e4LxQ",
  "container": "jy3Yu"
};
export {
  list_item_toggle_default as default,
  injectCss
};
//# sourceMappingURL=list-item-toggle-scss.js.map
